module.exports = __webpack_public_path__ + "img/shopGuide_2b_kr_1.cdd6ca40.jpg";